module.exports = __webpack_public_path__ + "img/10012.2af953cb.jpg";